import { setSpecificMessage, isoTime } from "valibot";
setSpecificMessage(
  isoTime,
  (issue) => `Temps invalide: reçu ${issue.received}`,
  "fr"
);